export class AppIdConstants {
  public static SAC_RES: string = 'SAC_RES';
  public static SAC_CALLCENTER: string = 'SAC_CALLCENTER';
  public static LEGALCERT_NOVA: string = 'LEGALCERT_NOVA';
}
